/**
 * A class containing all the information about the SB validation
 */
export class SBValidation {
    /**
     * Create a new SB Validation object
     * @param {User[]} strategicBuyers
     * @param {{}} denialInfo
     * @param {string} sbApprover
     */
    constructor(strategicBuyers, denialInfo, sbApprover) {
        this._strategicBuyers = strategicBuyers;
        this._denialInfo = denialInfo;
        this._sbApprover = sbApprover;
    }

    /**
     * Get an JS object containing all the information about the SB Validation.
     * @return {{strategicBuyers: User[], denialInfo: {}, sbApprover: string}}
     */
    getSBValidation() {
        return {
            strategicBuyers: this._strategicBuyers,
            denialInfo: this._denialInfo,
            sbApprover: this._sbApprover,
        };
    }

    /**
     * Get the strategic buyers
     * @return {User[]}
     */
    get strategicBuyers() {
        return this._strategicBuyers;
    }

    /**
     * Set the strategic buyers
     * @param {User[]} value
     */
    set strategicBuyers(value) {
        this._strategicBuyers = value;
    }

    /**
     * Get the denial info
     * @return {{}}
     */
    get denialInfo() {
        return this._denialInfo;
    }

    /**
     * Set the denial info
     * @param {{}} value
     */
    set denialInfo(value) {
        this._denialInfo = value;
    }

    /**
     * Get the sbApprover.
     * @return {string}
     */
    get sbApprover() {
        return this._sbApprover;
    }

    /**
     * Set the sbApprover.
     * @param {string} value
     */
    set sbApprover(value) {
        this._sbApprover = value;
    }
}
